import type { Index as LunrIndex } from 'lunr';

export const SEARCH_CATEGORIES = {
  ALL: 'AllCategory',
  BLOG: 'Blog',
  FAQ: 'FAQ',
  PRODUCT: 'Product',
} as const;

// see gatsby-config.js
export interface SearchResult {
  id: string;
  page: string;
  description: string;
  url: string;
  keywords: string[];
  category: string;
  productType: string;
}

export interface LunrWindowObject {
  index: LunrIndex;
  store: Record<string, SearchResult>;
}

declare global {
  interface Window {
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
    __LUNR__: any;
  }
}

interface FilterOptions {
  omitBlog: boolean
}

export const filterSearchResults = (results: SearchResult[], filterOptions: FilterOptions) => {
  const { omitBlog } = filterOptions;

  if (omitBlog) {
    return results.filter(
      (result) => result?.category !== SEARCH_CATEGORIES.BLOG && !result?.url?.includes('/blog/'),
    );
  }
  return results;
};

export const getLunrIndex = (
  locale: string,
): LunrWindowObject | null => typeof window !== "undefined" && window.__LUNR__?.[locale]
  ? window.__LUNR__?.[locale]
  : null;

export const createLunrQueryString = (query: string | null): string | null => {
  const trimmedQuery = (query ?? '')
    .replaceAll('?', '')
    .trim();

  return trimmedQuery.length > 0 ? `${trimmedQuery}*` : null;
};

export const lunrSearch = ({
  lunr,
  query,
}: { lunr?: LunrWindowObject | null, query: string; }): SearchResult[] => {
  const lunrQuery = createLunrQueryString(query);

  if (!lunrQuery || !lunr) {
    return [];
  }

  const hits = lunr.index.search(lunrQuery);
  return hits.map(({ ref }: LunrIndex.Result) => lunr.store[ref]);
};

export const filteredLunrSearch = ({
  lunr,
  query,
  omitBlog = true,
}: {
  lunr?: LunrWindowObject | null,
  query: string;
  omitBlog?: boolean
}): SearchResult[] => filterSearchResults(lunrSearch({ lunr, query }), { omitBlog });
